import React, { useState } from 'react'
import {BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill} from 'react-icons/bs'

const Carousel = ({slides}) => {

    // display info
    let width = window.innerWidth;

    // change slide in carousel
    let [current, setCurrent] = useState(0);

    if (current == 0) {
        var first_slide_pointer = 'none'
        var first_slide_opacity = '0%'

        var last_slide_pointer = 'auto'
        var last_slide_opacity = '100%'
    } else if (current == slides.length - 1) {
        last_slide_pointer = 'none'
        last_slide_opacity = '0%'

        first_slide_pointer = 'all'
        first_slide_opacity = '100%'
    }

    function previousButton() {
        setScreenMove(-1 * (current * width - width));
        setCurrent(current - 1);
    };

    function nextButton() {
        setScreenMove(-1 * (current * width + width));
        setCurrent(current + 1);
    };

    function previousSwipe() {
        if (current === 0) {
            setCurrent(slides.length - 1);
        } else {
            setCurrent(current - 1);
        }
    };

    function nextSwipe() {
        if (current === slides.length - 1) {
            setCurrent(0);
        } else {
            setCurrent(current + 1);
        }
    };

    // recognize swipes
    let [touchStart, setTouchStart] = useState(null)
    let [touchShift, setTouchShift] = useState(null)
    let [screenMove, setScreenMove] = useState(null)

    const onTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => {
        console.log(touchShift)
        if (((current == 0) && (touchShift > 0))) {

        } else if ((current == slides.length - 1) && (touchShift < 0)) {

        } else {
            setTouchShift(e.targetTouches[0].clientX - touchStart)
            setScreenMove(-1 * (current * width) + e.targetTouches[0].clientX - touchStart)
        }
    }

    const onTouchEnd = () => {
        if (Math.abs(touchShift) <= (width / 4)) {
            setScreenMove(-1 * current * width);
            setTouchShift(0);
        } else {
            if (touchShift < 0) {
                setScreenMove(-1 * (current * width - width * Math.sign(touchShift)));
                setTouchShift(0);
                nextSwipe();
            } else if (touchShift != 0) {
                setScreenMove(-1 * (current * width - width * Math.sign(touchShift)));
                setTouchShift(0);
                previousSwipe();
            }
        }
    }

  return (
    <div id='carousel' className='flex flex-col h-[100dvh] bg-black' onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
        <div className='fixed w-full px-10 flex justify-between items-end bottom-[calc((100dvh-80px)/4)] z-10 text-5xl text-white'>
            <button className='opacity-60 hover:opacity-100 hover:scale-125 hidden md:inline' onClick={previousButton} style={{pointerEvents: `${first_slide_pointer}`, opacity: `${first_slide_opacity}`}}>
                <BsFillArrowLeftCircleFill />
            </button>

            <button className='opacity-60 hover:opacity-100 hover:scale-125 hidden md:inline' onClick={nextButton} style={{pointerEvents: `${last_slide_pointer}`, opacity: `${last_slide_opacity}`}}>
                <BsFillArrowRightCircleFill />
            </button>
        </div>

        <div className='flex h-full w-full'>
            {slides.map((s,i) => {
                return <div className='fixed transition ease-out duration-200' style={{transform: `translateX(${i * width + screenMove}px)`}}> {s} </div>
            })}
        </div>
            
        <div className='absolute bottom-0 py-4 flex justify-center gap-8 w-full'>
            {slides.map((s, i) => {
                return (
                    <div key={i} className={`rounded-full w-3 h-3 bg-white ${i==current? 'brightness-150' : 'brightness-50'}`}></div>
                );
            })}
        </div>
    </div>
  )
}

export default Carousel